import React from 'react';
import Layout from './components/base.jsx';
import Hero from './components/Hero';
import Features from './components/Features';
import Argument from './components/Argument.jsx';
import Carrusel from './components/ActionSection';
import StatsSection from './components/StatsSection';
import Partners from './components/Partners';
import ContactForm from './components/ContactForm';
import WhatsAppBanner from './components/Banner.jsx';


function App() {
  return (
    <Layout>
      <Hero />
      
      <Argument />
      <Features />
      <Carrusel />
      <StatsSection />
      <Partners />
      <ContactForm />

      <WhatsAppBanner />

    </Layout>
  );
}

export default App;
